module.exports = __webpack_public_path__ + "img/loginBg.99febaf1.jpg";